import Joi from 'joi';

export const boxCountSchema = Joi.number()
  .min(1)
  .max(999999)
  .required()
  .messages({ 'number.base': `Please enter box count`, 'number.min': 'Box count must be greater than or equal to 1' });
